import { Image } from '../../../../components/Image/Image';
import styles from './Challenges.module.scss';
export const Challenges = ({content})=>{
  if(!content) return;
  const {title,blocks} = content;
return (
  <>
    {title && <div className={styles.title}>{title}</div>}
    <div className={styles.blocks}>
      {blocks.map((block,i)=>{
        const {title:boxTitle,icon,list} = block;
        return (
          <div className={styles.box} key={i}>
            {icon && <Image className={styles.boxIcon} src={icon}/>}
            {boxTitle && <div className={styles.boxTitle}>{boxTitle}</div>}
            {list && <ul className={styles.boxList}>
              {list.map((item, i)=>{
                return <li key={i} className={styles.boxItem}>{item}</li>
              })}
            </ul>}
          </div>
        )
      })}
    </div>
  </>
)
}